import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';

export const environment: IEnvironment = {
  modules: [],
  production: true,
  routes: [],
  version: buildVersion as BuildVersion,
};
